import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FJHairstyleChangerRight from '../view/FJHairstyleChangerRight';
import FJActionHairstyleChanger from '../../../../redux/action/FJActionHairstyleChanger';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon';

function FJHairstyleChangerRightContainer() {
    const dispatch = useDispatch();

    const taskStatus = useSelector(state => state.common.taskStatus);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const isCanDownload = useSelector(state => state.common.isDone);

    const [downloadEditImageLoading, setDownloadEditImageLoading] = useState(false);

    const uploadImg = file => {
        dispatch(FJActionHairstyleChanger.uploadImageAction(file));
    };
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };

    const download = () => {
        setDownloadEditImageLoading(true);
        dispatch(FJActionHairstyleChanger.downloadAllCreationAction(() => setDownloadEditImageLoading(false)));
    };

    const imageToVideo = () => {
        dispatch(FJActionHairstyleChanger.animateImageAction());
    };

    const handleRetry = useCallback(
        id => {
            dispatch(FJActionHairstyleChanger.reGenerateAction(id));
        },
        [dispatch],
    );

    return (
        <FJHairstyleChangerRight
            onRetry={handleRetry}
            uploadImg={uploadImg}
            setIsDraggingFile={_setIsDraggingFile}
            taskStatus={taskStatus}
            headerTabIndex={headerTabIndex}
            isCanDownload={isCanDownload}
            download={download}
            imageToVideo={imageToVideo}
            downloadEditImageLoading={downloadEditImageLoading}
        />
    );
}

export default FJHairstyleChangerRightContainer;
